import { useState, useEffect } from 'react';
import apiClient from '../../Api/apiClient';

const LocationSelector = ({ onSelectLocation }) => {
  const [districts, setDistricts] = useState([]);
  const [upazilas, setUpazilas] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedUpazila, setSelectedUpazila] = useState(null);
  const [searchTermDistrict, setSearchTermDistrict] = useState('');
  const [searchTermUpazila, setSearchTermUpazila] = useState('');
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredUpazilas, setFilteredUpazilas] = useState([]);
  const [showDistrictSuggestions, setShowDistrictSuggestions] = useState(false);
  const [showUpazilaSuggestions, setShowUpazilaSuggestions] = useState(false);
  const [districtIndex, setDistrictIndex] = useState(-1);
  const [upazilaIndex, setUpazilaIndex] = useState(-1);

  useEffect(() => {
    apiClient
      .get('/user/visitor/district')
      .then(response => {
        setDistricts(response.data.data);
        setFilteredDistricts(response.data.data);
      })
      .catch(error => console.error('Error fetching districts:', error));
  }, []);

  useEffect(() => {
    if (selectedDistrict) {
      const districtData = districts.find(
        d => d.id === parseInt(selectedDistrict.id)
      );
      if (districtData?.upazilas) {
        setUpazilas(districtData.upazilas);
        setFilteredUpazilas(districtData.upazilas);
      } else {
        setUpazilas([]);
        setFilteredUpazilas([]);
      }
    }
  }, [selectedDistrict, districts]);

  useEffect(() => {
    setFilteredDistricts(
      districts.filter(d =>
        d.name?.toLowerCase().includes(searchTermDistrict.toLowerCase())
      )
    );
  }, [searchTermDistrict, districts]);

  useEffect(() => {
    setFilteredUpazilas(
      upazilas.filter(u =>
        u.name?.toLowerCase().includes(searchTermUpazila.toLowerCase())
      )
    );
  }, [searchTermUpazila, upazilas]);

  const handleDistrictKeyDown = e => {
    if (e.key === 'ArrowDown') {
      setDistrictIndex(prev =>
        Math.min(prev + 1, filteredDistricts.length - 1)
      );
    } else if (e.key === 'ArrowUp') {
      setDistrictIndex(prev => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter' && districtIndex >= 0) {
      const district = filteredDistricts[districtIndex];
      setSelectedDistrict(district);
      setSearchTermDistrict(district.name);
      setShowDistrictSuggestions(false);
      onSelectLocation(district.id, district.name, null, null);
    }
  };

  const handleUpazilaKeyDown = e => {
    if (e.key === 'ArrowDown') {
      setUpazilaIndex(prev => Math.min(prev + 1, filteredUpazilas.length - 1));
    } else if (e.key === 'ArrowUp') {
      setUpazilaIndex(prev => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter' && upazilaIndex >= 0) {
      const upazila = filteredUpazilas[upazilaIndex];
      setSelectedUpazila(upazila);
      setSearchTermUpazila(upazila.name);
      setShowUpazilaSuggestions(false);
      onSelectLocation(
        selectedDistrict.id,
        selectedDistrict.name,
        upazila.id,
        upazila.name
      );
    }
  };

  return (
    <div className="flex items-center gap-2 text-xs">
      <div className="relative w-full">
        <input
          type="text"
          placeholder="Search District"
          value={searchTermDistrict}
          onChange={e => {
            setSearchTermDistrict(e.target.value);
            setDistrictIndex(-1);
          }}
          className="border p-2 w-full rounded-md text-xs"
          onFocus={() => setShowDistrictSuggestions(true)}
          onBlur={() =>
            setTimeout(() => setShowDistrictSuggestions(false), 200)
          }
          onKeyDown={handleDistrictKeyDown}
        />
        {showDistrictSuggestions && (
          <ul className="absolute w-full border bottom-full bg-white mt-1 max-h-40 overflow-y-auto text-left shadow-md rounded-md text-xs">
            {filteredDistricts.map((district, index) => (
              <li
                key={district.id}
                onClick={() => {
                  setSelectedDistrict(district);
                  setSearchTermDistrict(district.name);
                  setShowDistrictSuggestions(false);
                  onSelectLocation(district.id, district.name, null, null);
                }}
                className={`p-2 cursor-pointer hover:bg-gray-300 ${
                  index === districtIndex ? 'bg-gray-200' : ''
                }`}
              >
                {district.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="relative w-full">
        <input
          type="text"
          placeholder="Search Upazila"
          value={searchTermUpazila}
          onChange={e => {
            setSearchTermUpazila(e.target.value);
            setUpazilaIndex(-1);
          }}
          disabled={!selectedDistrict}
          className="border p-2 w-full rounded-md text-xs"
          onFocus={() => setShowUpazilaSuggestions(true)}
          onBlur={() => setTimeout(() => setShowUpazilaSuggestions(false), 200)}
          onKeyDown={handleUpazilaKeyDown}
        />
        {showUpazilaSuggestions && (
          <ul className="absolute w-full border bottom-full bg-white mt-1 max-h-40 overflow-y-auto text-left shadow-md rounded-md text-xs">
            {filteredUpazilas.map((upazila, index) => (
              <li
                key={upazila.id}
                onClick={() => {
                  setSelectedUpazila(upazila);
                  setSearchTermUpazila(upazila.name);
                  setShowUpazilaSuggestions(false);
                  onSelectLocation(
                    selectedDistrict.id,
                    selectedDistrict.name,
                    upazila.id,
                    upazila.name
                  );
                }}
                className={`p-2 cursor-pointer hover:bg-gray-300 ${
                  index === upazilaIndex ? 'bg-gray-200' : ''
                }`}
              >
                {upazila.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default LocationSelector;

// import { useState, useEffect } from 'react';
// import apiClient from '../../Api/apiClient';

// const LocationSelector = ({ onSelectLocation }) => {
//   const [districts, setDistricts] = useState([]);
//   const [upazilas, setUpazilas] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState(null);
//   const [selectedUpazila, setSelectedUpazila] = useState(null);
//   const [searchTermDistrict, setSearchTermDistrict] = useState('');
//   const [searchTermUpazila, setSearchTermUpazila] = useState('');
//   const [filteredDistricts, setFilteredDistricts] = useState([]);
//   const [filteredUpazilas, setFilteredUpazilas] = useState([]);
//   const [showDistrictSuggestions, setShowDistrictSuggestions] = useState(false);
//   const [showUpazilaSuggestions, setShowUpazilaSuggestions] = useState(false);

//   // Fetch districts from API
//   useEffect(() => {
//     apiClient
//       .get('/user/visitor/district')
//       .then(response => {
//         setDistricts(response.data.data);
//         setFilteredDistricts(response.data.data); // Initialize with all districts
//       })
//       .catch(error => {
//         console.error('Error fetching districts:', error);
//       });
//   }, []);

//   // Update upazilas when a district is selected
//   useEffect(() => {
//     if (selectedDistrict) {
//       const selectedDistrictData = districts.find(
//         district => district.id === parseInt(selectedDistrict.id)
//       );

//       if (selectedDistrictData && selectedDistrictData.upazilas) {
//         setUpazilas(selectedDistrictData.upazilas);
//         setFilteredUpazilas(selectedDistrictData.upazilas); // Initialize with all upazilas
//       } else {
//         setUpazilas([]);
//         setFilteredUpazilas([]);
//       }
//     }
//   }, [selectedDistrict, districts]);

//   // Filter districts based on search term
//   useEffect(() => {
//     if (searchTermDistrict) {
//       setFilteredDistricts(
//         districts.filter(d =>
//           d.name?.toLowerCase().includes(searchTermDistrict.toLowerCase())
//         )
//       );
//     } else {
//       setFilteredDistricts(districts);
//     }
//   }, [searchTermDistrict, districts]);

//   // Filter upazilas based on search term
//   useEffect(() => {
//     if (searchTermUpazila) {
//       setFilteredUpazilas(
//         upazilas.filter(u =>
//           u.name?.toLowerCase().includes(searchTermUpazila.toLowerCase())
//         )
//       );
//     } else {
//       setFilteredUpazilas(upazilas);
//     }
//   }, [searchTermUpazila, upazilas]);

//   return (
//     <div className="flex items-center gap-2">
//       {/* District Selection */}
//       <div className="relative w-full">
//         <input
//           type="text"
//           placeholder="Search District"
//           value={searchTermDistrict}
//           onChange={e => setSearchTermDistrict(e.target.value)}
//           className="border p-2 w-full"
//           onFocus={() => setShowDistrictSuggestions(true)}
//           onBlur={() =>
//             setTimeout(() => setShowDistrictSuggestions(false), 200)
//           }
//         />
//         {showDistrictSuggestions && (
//           <ul className="absolute w-full border bottom-full bg-white mt-1 max-h-40 overflow-y-auto text-left shadow-md">
//             {filteredDistricts.map(district => (
//               <li
//                 key={district.id}
//                 onClick={() => {
//                   setSelectedDistrict(district);
//                   setSearchTermDistrict(district.name);
//                   setShowDistrictSuggestions(false);
//                   onSelectLocation(district.id, district.name, null, null);
//                 }}
//                 className="p-2 cursor-pointer hover:bg-gray-300"
//               >
//                 {district.name}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>

//       {/* Upazila Selection */}
//       <div className="relative w-full">
//         <input
//           type="text"
//           placeholder="Search Upazila"
//           value={searchTermUpazila}
//           onChange={e => setSearchTermUpazila(e.target.value)}
//           disabled={!selectedDistrict}
//           className="border p-2 w-full"
//           onFocus={() => setShowUpazilaSuggestions(true)}
//           onBlur={() => setTimeout(() => setShowUpazilaSuggestions(false), 200)}
//         />
//         {showUpazilaSuggestions && (
//           <ul className="absolute w-full border bottom-full bg-white mt-1 max-h-40 overflow-y-auto text-left shadow-md">
//             {filteredUpazilas.map(upazila => (
//               <li
//                 key={upazila.id}
//                 onClick={() => {
//                   setSelectedUpazila(upazila);
//                   setSearchTermUpazila(upazila.name);
//                   setShowUpazilaSuggestions(false);
//                   onSelectLocation(
//                     selectedDistrict.id,
//                     selectedDistrict.name,
//                     upazila.id,
//                     upazila.name
//                   );
//                 }}
//                 className="p-2 cursor-pointer hover:bg-gray-300"
//               >
//                 {upazila.name}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LocationSelector;

// import { useState, useEffect } from 'react';
// import apiClient from '../../Api/apiClient';

// const LocationSelector = ({ onSelectLocation }) => {
//   const [districts, setDistricts] = useState([]);
//   const [upazilas, setUpazilas] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedUpazila, setSelectedUpazila] = useState('');
//   const [searchTermDistrict, setSearchTermDistrict] = useState('');
//   const [searchTermUpazila, setSearchTermUpazila] = useState('');
//   const [filteredDistricts, setFilteredDistricts] = useState([]);
//   const [filteredUpazilas, setFilteredUpazilas] = useState([]);
//   const [highlightedIndex, setHighlightedIndex] = useState(-1);
//   const [showDistrictSuggestions, setShowDistrictSuggestions] = useState(false);
//   const [showUpazilaSuggestions, setShowUpazilaSuggestions] = useState(false);

//   // Fetch districts from API
//   useEffect(() => {
//     apiClient
//       .get('/user/visitor/district')
//       .then(response => {
//         console.log('Fetched districts:', response.data.data);
//         setDistricts(response.data.data);
//         setFilteredDistricts(response.data.data); // Show all districts by default
//       })
//       .catch(error => console.error('Error fetching districts:', error));
//   }, []);

//   // Update upazilas when a district is selected
//   useEffect(() => {
//     if (selectedDistrict) {
//       const selectedDistrictData = districts.find(
//         district => district.id === parseInt(selectedDistrict)
//       );

//       if (selectedDistrictData?.upazilas) {
//         setUpazilas(selectedDistrictData.upazilas);
//         setFilteredUpazilas(selectedDistrictData.upazilas);
//       } else {
//         setUpazilas([]);
//         setFilteredUpazilas([]);
//       }
//     }
//   }, [selectedDistrict, districts]);

//   // Filter districts based on search term
//   useEffect(() => {
//     if (searchTermDistrict.trim()) {
//       const filtered = districts.filter(d =>
//         d?.name?.toLowerCase()?.includes(searchTermDistrict.toLowerCase())
//       );
//       setFilteredDistricts(filtered);
//     } else {
//       setFilteredDistricts(districts); // Show all if empty
//     }
//   }, [searchTermDistrict, districts]);

//   // Filter upazilas based on search term
//   useEffect(() => {
//     if (searchTermUpazila.trim()) {
//       const filtered = upazilas.filter(u =>
//         u?.name?.toLowerCase()?.includes(searchTermUpazila.toLowerCase())
//       );
//       setFilteredUpazilas(filtered);
//     } else {
//       setFilteredUpazilas(upazilas);
//     }
//   }, [searchTermUpazila, upazilas]);

//   // Handle keyboard navigation
//   const handleKeyDown = (event, type) => {
//     let list = type === 'district' ? filteredDistricts : filteredUpazilas;
//     let setter = type === 'district' ? setSelectedDistrict : setSelectedUpazila;
//     let termSetter =
//       type === 'district' ? setSearchTermDistrict : setSearchTermUpazila;
//     let showSetter =
//       type === 'district'
//         ? setShowDistrictSuggestions
//         : setShowUpazilaSuggestions;

//     if (event.key === 'ArrowDown') {
//       setHighlightedIndex(prev => (prev < list.length - 1 ? prev + 1 : prev));
//     } else if (event.key === 'ArrowUp') {
//       setHighlightedIndex(prev => (prev > 0 ? prev - 1 : prev));
//     } else if (event.key === 'Enter' && highlightedIndex >= 0) {
//       setter(list[highlightedIndex]?.id);
//       termSetter(list[highlightedIndex]?.name);
//       showSetter(false);
//       setHighlightedIndex(-1);
//     }
//   };

//   return (
//     <div className="flex items-center gap-2 text-xs">
//       {/* District Selection */}
//       <div className="relative">
//         <input
//           type="text"
//           placeholder="Search District"
//           value={searchTermDistrict}
//           onChange={e => setSearchTermDistrict(e.target.value)}
//           onFocus={() => setShowDistrictSuggestions(true)}
//           onBlur={() =>
//             setTimeout(() => setShowDistrictSuggestions(false), 200)
//           }
//           onKeyDown={e => handleKeyDown(e, 'district')}
//           className="border p-2 w-full rounded-md"
//         />
//         {showDistrictSuggestions && (
//           <ul className="absolute w-full border bg-white mt-1 max-h-40 overflow-y-auto text-left rounded-md">
//             {filteredDistricts.map((district, index) => (
//               <li
//                 key={district.id}
//                 onClick={() => {
//                   setSelectedDistrict(district.id);
//                   setSearchTermDistrict(district.name);
//                   setShowDistrictSuggestions(false);
//                 }}
//                 className={`p-2 cursor-pointer ${
//                   highlightedIndex === index ? 'bg-gray-300' : 'bg-white'
//                 }`}
//               >
//                 {district.name}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>

//       {/* Upazila Selection */}
//       <div className="relative">
//         <input
//           type="text"
//           placeholder="Search Upazila"
//           value={searchTermUpazila}
//           onChange={e => setSearchTermUpazila(e.target.value)}
//           onFocus={() => setShowUpazilaSuggestions(true)}
//           onBlur={() => setTimeout(() => setShowUpazilaSuggestions(false), 200)}
//           onKeyDown={e => handleKeyDown(e, 'upazila')}
//           disabled={!selectedDistrict}
//           className="border p-2 w-full rounded-md"
//         />
//         {showUpazilaSuggestions && selectedDistrict && (
//           <ul className="absolute w-full border bg-white mt-1 max-h-40 overflow-y-auto text-left rounded-md">
//             {filteredUpazilas.map((upazila, index) => (
//               <li
//                 key={upazila.id}
//                 onClick={() => {
//                   setSelectedUpazila(upazila.id);
//                   setSearchTermUpazila(upazila.name);
//                   setShowUpazilaSuggestions(false);
//                 }}
//                 className={`p-2 cursor-pointer ${
//                   highlightedIndex === index ? 'bg-gray-300' : 'bg-white'
//                 }`}
//               >
//                 {upazila.name}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LocationSelector;
